import { Box } from '@mui/material';
import { tokens } from '../theme';

type Tone = 'success' | 'warning' | 'error' | 'info' | 'neutral';

const TONES: Record<Tone, { bg: string; fg: string; dot: string }> = {
  success: { bg: tokens.successSoft, fg: tokens.success, dot: '#079455' },
  warning: { bg: tokens.warnSoft, fg: tokens.warn, dot: '#DC6803' },
  error: { bg: tokens.errorSoft, fg: tokens.error, dot: '#D92D20' },
  info: { bg: tokens.tint, fg: tokens.blueDeep, dot: tokens.blue },
  neutral: { bg: tokens.strip, fg: '#344054', dot: tokens.text3 },
};

const APP_TONES: Record<string, Tone> = {
  live: 'success',
  beta: 'info',
  planned: 'neutral',
  maintenance: 'warning',
};

const SVC_TONES: Record<string, Tone> = {
  operational: 'success',
  degraded: 'warning',
  outage: 'error',
  maintenance: 'info',
};

const REQ_TONES: Record<string, Tone> = {
  submitted: 'neutral',
  reviewing: 'info',
  scheduled: 'info',
  in_progress: 'warning',
  delivered: 'success',
  declined: 'error',
};

function Pill({ tone, label }: { tone: Tone; label: string }) {
  const t = TONES[tone];
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.75,
        px: 1.25,
        py: 0.25,
        borderRadius: 999,
        bgcolor: t.bg,
        color: t.fg,
        fontSize: 13,
        fontWeight: 600,
        whiteSpace: 'nowrap',
        textTransform: 'capitalize',
        lineHeight: 1.6,
      }}
    >
      <Box component="span" aria-hidden sx={{ width: 7, height: 7, borderRadius: '50%', bgcolor: t.dot }} />
      {label}
    </Box>
  );
}

export function AppStatusChip({ status }: { status: string }) {
  return <Pill tone={APP_TONES[status] ?? 'neutral'} label={status.replace('_', ' ')} />;
}

export function ServiceStatusChip({ status }: { status: string }) {
  return <Pill tone={SVC_TONES[status] ?? 'neutral'} label={status} />;
}

export function RequestStatusChip({ status }: { status: string }) {
  return <Pill tone={REQ_TONES[status] ?? 'neutral'} label={status.replace('_', ' ')} />;
}
